import {
  createTheme,
  CssBaseline,
  ThemeProvider,
  useMediaQuery,
} from "@material-ui/core"
import throttle from "lodash.throttle"
import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import { HashRouter as Router } from "react-router-dom"

import App from "./App"
import { SnackProvider } from "./components/Snackbar"
import store from "./store"
import { persistState } from "./store/storage"

const EntryPoint: React.FC = () => {
  React.useEffect(() => {
    return store.subscribe(
      throttle(() => {
        persistState(store.getState())
      }, 1000)
    )
  })

  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)")
  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          type: prefersDarkMode ? "dark" : "light",
        },
      }),
    [prefersDarkMode]
  )

  return (
    <Provider store={store}>
      <Router>
        <ThemeProvider theme={theme}>
          <CssBaseline>
            <SnackProvider>
              <App />
            </SnackProvider>
          </CssBaseline>
        </ThemeProvider>
      </Router>
    </Provider>
  )
}

async function init() {
  const el = document.querySelector("[rel=app]")
  if (!el) {
    throw new Error("unable to find target element")
  }

  ReactDOM.render(<EntryPoint />, el)
}

init()
